/*
 * Cart stock cap (Phase 3, Task 5b — safe rebuild) — B2C + B2B.
 * Same intent as the bulk table: a product's combined variant quantity can't exceed
 * the (edited) variant's stock. In the cart we enforce this WITHOUT ever changing a
 * quantity value (that's what broke the cart before): we only disable / block the "+"
 * button when the cap is reached. Decrease and remove are never touched.
 *
 * Notes:
 * - Pinnacle renders two qty inputs per line (mobile + desktop). We count each line
 *   once by de-duping on data-index before summing per product (data-item-id).
 * - Only stock-tracked (deny) variants carry data-quantity-item-limit, so untracked /
 *   continue-selling variants are never capped.
 */
(function () {
  if (window.__customCartStockCap) return;
  window.__customCartStockCap = true;

  function isCartCapInput(el) {
    return (
      el &&
      el.matches &&
      el.matches('input[data-quantity-item-limit][data-item-id]') &&
      !el.closest('custom-b2b-bulk-order') // the bulk element handles its own inputs
    );
  }

  function lineKey(input) {
    return input.dataset.index != null ? 'i' + input.dataset.index : 'v' + input.dataset.quantityVariantId;
  }

  // Combined quantity per product (data-item-id), counting each line once.
  function productTotals() {
    var perLine = {};
    document.querySelectorAll('input[data-quantity-item-limit][data-item-id]').forEach(function (i) {
      if (!isCartCapInput(i)) return;
      var v = parseInt(i.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      perLine[lineKey(i)] = { itemId: i.dataset.itemId, qty: v };
    });
    var totals = {};
    Object.keys(perLine).forEach(function (k) {
      var e = perLine[k];
      totals[e.itemId] = (totals[e.itemId] || 0) + e.qty;
    });
    return totals;
  }

  function atCap(input, totals) {
    var limit = parseInt(input.getAttribute('data-quantity-item-limit'), 10);
    if (isNaN(limit)) return false;
    var step = parseInt(input.step, 10) || 1;
    return (totals[input.dataset.itemId] || 0) + step > limit;
  }

  // Toggle the disabled state of every cart "+" button (visual feedback).
  function refresh() {
    var totals = productTotals();
    document.querySelectorAll('input[data-quantity-item-limit][data-item-id]').forEach(function (i) {
      if (!isCartCapInput(i)) return;
      var wrap = i.closest('.quantity');
      if (!wrap) return;
      var plus = wrap.querySelector('.plus');
      if (!plus) return;
      plus.disabled = atCap(i, totals);
      plus.classList.toggle('custom-qty-capped', plus.disabled);
    });
  }

  // Authoritative block: prevent the "+" increment at cap regardless of disabled state.
  document.addEventListener(
    'click',
    function (e) {
      var plus = e.target.closest ? e.target.closest('.quantity .plus') : null;
      if (!plus) return;
      var wrap = plus.closest('.quantity');
      var input = wrap ? wrap.querySelector('input[data-quantity-item-limit][data-item-id]') : null;
      if (!isCartCapInput(input)) return;
      if (atCap(input, productTotals())) {
        e.preventDefault();
        e.stopImmediatePropagation();
        plus.disabled = true;
        plus.classList.add('custom-qty-capped');
      }
    },
    true
  );

  // Re-apply after Pinnacle re-renders the cart / drawer (childList only — setting
  // .disabled is an attribute change, so this never re-triggers itself).
  function observe() {
    ['Cart', 'Cart-Drawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      new MutationObserver(function () {
        refresh();
      }).observe(el, { childList: true, subtree: true });
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
